import {Constructor} from "../../../../global/constructor";
import {
  ICertificateElementContainer,
  ISortableCertificateElement,
} from "~/interfaces/contentManagementInterfaces";
import TrackedModel from "~/models/tracked/trackedModel";
import Certificate from "../certificate";

export default function DynamicImageElement<TBase extends Constructor,
  TCertificateElement extends ISortableCertificateElement &
    TrackedModel,
  TContainer extends TrackedModel &
    ICertificateElementContainer<TCertificateElement> &
    TCertificateElement>(Base: TBase) {
  return class extends Base {
    underlying_variable: string;
    width: 200;
    height: 150;
    certificate: Certificate;

    live_data(repeatableIndex: number = null, scopedLiveData = null) {
      if (scopedLiveData){
        if (!scopedLiveData[this.underlying_variable]){
          console.log("here")
        }else{
          return scopedLiveData[this.underlying_variable]
        }
      }else{
        return this.certificate.getMappedDataValue(this.underlying_variable, repeatableIndex)
      }
    }

    upload_url(repeatableIndex: number = null, scopedLiveData = null) {
      const live_data = this.live_data(repeatableIndex, scopedLiveData)
      return !!live_data ? live_data.url : null
    }

    crop_data(repeatableIndex: number = null, scopedLiveData = null) {
      const live_data = this.live_data(repeatableIndex, scopedLiveData)
      return !!live_data ? live_data.crop_data : null
    }
  }
}